import React, { useState, useEffect, useCallback } from 'react'
import { Grid, Button, Tabs, Tab } from '@mui/material'

// styles
import { useTranslation } from 'react-i18next'
import useStyles from './styles'

// components
import PageTitle from '../../components/PageTitle'
import { useDataApi } from '../../context/DataApiContext'
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer'
import Loading from '../../components/Loading'
import { useNotificationsProvider } from '../../context/NotificationsContext'
import ManagePVAdmissionDialog from '../../components/PVAdmissionManagement'

const DOCUMENT_TYPES = [
  { value: 'acquisition', label: 'pv-admission-management.type-acquisition' },
  { value: 'location', label: 'pv-admission-management.type-location' },
  { value: 'refaction', label: 'pv-admission-management.type-refaction' },
  { value: 'reserve', label: 'pv-admission-management.type-reserve' },
]

export default function PVAdmissionManagement() {
  const { t } = useTranslation()
  const classes = useStyles()
  const { dataProvider } = useDataApi()
  const { showNotification } = useNotificationsProvider()

  const [failedLoad, setFailedLoad] = useState(false)
  const [document, setDocument] = useState(null)
  const [openManagePVAdmission, setOpenManagePVAdmission] = useState(false)
  const [documentType, setDocumentType] = useState('acquisition')

  const onManageDocument = () => {
    setOpenManagePVAdmission(true)
  }

  const fetchDocument = useCallback(() => {
    setDocument(null)
    dataProvider.chassis
      .getPVAdmissionManagement(documentType)
      .then((response) => setDocument(response.data))
      .catch(() => {
        setDocument(false)
        setFailedLoad(true)
      })
  }, [dataProvider, documentType])

  useEffect(() => {
    fetchDocument()
  }, [fetchDocument])

  useEffect(() => {
    if (!failedLoad) {
      return
    }

    showNotification('error', t('errors.api-error'))
    setFailedLoad(false)
  }, [showNotification, failedLoad, t])

  const handleDocumentTypeChange = (event, newValue) => {
    setDocumentType(newValue)
  }

  return (
    <>
      <ManagePVAdmissionDialog
        open={openManagePVAdmission}
        documentType={documentType}
        onClose={() => {
          setOpenManagePVAdmission(false)
        }}
        onCreated={() => {
          fetchDocument()
          setOpenManagePVAdmission(false)
        }}
      />
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs={12} sm={4}>
          <PageTitle title={t('pv-admission-management.title')} />
        </Grid>
        <Grid item container sm={8} justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={onManageDocument}
          >
            {t('pv-admission-management.manage-pv-admission')}
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginBottom: 16 }}>
        <Grid item xs={12}>
          <Tabs
            value={documentType}
            onChange={handleDocumentTypeChange}
            indicatorColor="primary"
            textColor="primary"
          >
            {DOCUMENT_TYPES.map((dt) => (
              <Tab key={dt.value} value={dt.value} label={t(dt.label)} />
            ))}
          </Tabs>
        </Grid>
      </Grid>
      {document === null ? (
        <Loading />
      ) : document === false ? null : (
        <Grid container spacing={4} className={classes.previewGridContainer}>
          <Grid item className={classes.previewGridItem}>
            <DocViewer
              style={{ height: 550 }}
              config={{
                header: {
                  disableHeader: false,
                  disableFileName: false,
                  retainURLParams: false,
                },
              }}
              pluginRenderers={DocViewerRenderers}
              documents={[document]}
            />
          </Grid>
        </Grid>
      )}
    </>
  )
}
